import { ComponentIds, StlSystemIds, } from "@inter-ikea-core/core";
import { SystemBase } from "@inter-ikea-core/core-toolbox";
import RemovedLeftSideUnitComponent from "../components/RemovedLeftSideUnitComponent";
import RemovedRightSideUnitComponent from "../components/RemovedRightSideUnitComponent";
import { entityIsSection } from "../functions/attachedTo";
import logEmptyFunctionWarning from "../functions/logEmptyFunctionWarning";
import { removeAlignmentConnectionsComponentFrom } from "../utils/entityUtils";
export class RefreshSectionsAlignmentsOnDragSystem extends SystemBase {
    constructor(entityManager) {
        super(ComponentIds.SOMETHING_IS_DRAGGED_COMPONENT_ID);
        this.entityManager = entityManager;
        this.doingChangesOnComponent = [
            RemovedLeftSideUnitComponent.id,
            RemovedRightSideUnitComponent.id,
        ];
        this.id = "RefreshSectionsAlignmentsOnDragSystem";
        this.previouslyAlignedEntity = null;
        this.systemsAfterMe = null;
        this.systemsBeforeMe = null;
    }
    forceRefreshEntitiesAlignments(_entities) {
        const alignmentConnectionCreationSystemRegisteredAndEnabled = this.entityManager
            .getSystemsRegistered()
            .filter((system) => system.isEnabled)
            .find((system) => system.id === StlSystemIds.ALIGNMENT_CONNECTION_CREATION_SYSTEM);
        if (alignmentConnectionCreationSystemRegisteredAndEnabled) {
            alignmentConnectionCreationSystemRegisteredAndEnabled.refreshAlignments(_entities);
        }
    }
    onAddComponent(_entity, _newComponent) {
        if (entityIsSection(_newComponent.entity)) {
            this.previouslyAlignedEntity = _newComponent.entity;
            this.forceRefreshEntitiesAlignments([this.previouslyAlignedEntity]);
            removeAlignmentConnectionsComponentFrom([_newComponent.entity]);
        }
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        logEmptyFunctionWarning("onUpdateComponent", this.id);
    }
    onRemoveComponent(_entity, _oldComponent) {
        if (this.previouslyAlignedEntity) {
            this.forceRefreshEntitiesAlignments([this.previouslyAlignedEntity]);
            this.previouslyAlignedEntity = null;
        }
    }
}
